import { ICourseStudentsResponse } from '@/types/views/student.types';
import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { queryKeys } from './queryKeys';
import { useAppQuery } from './useAppQuery';

interface Props {
  courseId?: string;
  statusFilter?: string[];
  searchText?: string;
  paginationModel?: GridPaginationModel;
  enabled?: boolean;
}

export const useGetCourseStudents = ({
  courseId,
  statusFilter,
  searchText,
  paginationModel,
  enabled = true,
}: Props) => {

  const params = {
    statusFilter: statusFilter?.length ? statusFilter : undefined,
    searchText: searchText || undefined,
    pageNumber: (paginationModel?.page || 0) + 1,
    pageSize: paginationModel?.pageSize || undefined,
  }

  return useAppQuery<ICourseStudentsResponse>(`/TrainingManager/courses/${courseId}/students`, {
    config: {
      params,
      paramsSerializer: { indexes: null },
    },
    enabled: !!courseId && enabled,
    // Inherit useAppQuery's keepPreviousData: during a page change the grid keeps the previous
    // rows/totalCount, so DataGrid never sees rowCount drop to 0 and clamp the page back to 0.
    queryKey: queryKeys.courseStudents.list(params),
  });
};
